export default "__VITE_ASSET__d217bbe0__"